import React, {useCallback, useEffect, useMemo, useState} from 'react';
import {useController} from 'react-hook-form';
import Action from "./Action";
import {toggleObjectInArray} from "../../../../../utils/utils";

interface ActionItem {
    placeholder: string;
    value: unknown;
    nomeAcao: string;
    codAcaoSeq: string | number;
    [key: string]: any;
}

interface ActionsGroupProps {
    name: string;
    control: any;
    rules?: object;
    title: string;
    title2?: string;
    onChangeDefault?: () => void;
    notRequired?: boolean;
    requiredColor?: string;
    actions?: ActionItem[];
    nameAction?: string;
    descAction?: string;
    id?: string;
}

const ActionsGroup: React.FC<ActionsGroupProps> = ({
                                                       name,
                                                       control,
                                                       rules,
                                                       title,
                                                       title2,
                                                       onChangeDefault,
                                                       notRequired = false,
                                                       requiredColor = '#0061C6',
                                                       actions = [],
                                                       nameAction,
                                                       descAction,
                                                       id = 'id',
                                                   }) => {
    const {
        field: { onChange },
        fieldState: { error },
    } = useController({ control, name, rules });

    const [filteredActions, setFilteredActions] = useState<ActionItem[]>([]);

    actions.sort((a, b) => {
        const valorA = a['nomeAcao'];
        const valorB = b['nomeAcao'];
        const direction = 'ASC';
        // @ts-ignore
        if (direction === 'DESC') {
            if (valorA < valorB) return 1;
            if (valorA > valorB) return -1;
        } else {
            if (valorA < valorB) return -1;
            if (valorA > valorB) return 1;
        }
        return 0;
    });

    useEffect(() => {
        if (actions.length) {
            const filtered = actions.filter(i => i.id !== null);
            setFilteredActions(filtered);
        }
    }, [actions]);

    useEffect(() => {
        onChange(filteredActions);
    }, [filteredActions, onChange]);

    const renderError = () =>
        error && error.message ? (
            <p
                style={{
                    color: error?.message ? '#F5365C' : '#000000',
                }}
            >
                {error?.message}
            </p>
        ) : null;

    const checkItens = async (item: ActionItem) => {
        setFilteredActions(prevState => toggleObjectInArray(prevState, item, 'codAcaoSeq'));
    };

    const handleItens = useCallback(
        (item: string | number, index: string, targetValue: unknown) => {
            const newValue = filteredActions?.map((i) => {
                if (i[id] === item) {
                    i[index] = targetValue;
                }
                return i;
            });
            onChange(newValue);
        },
        [onChange, filteredActions, id]
    );

    const renderItems = useMemo(() => {
        return (
            <>
                {actions?.map((item, index) => {
                    return (
                        <Action
                            key={index}
                            {...{ name, control, rules, onChangeDefault }}
                            disabled={!filteredActions?.find((i) => i['codAcaoSeq'] === item['codAcaoSeq'])}
                            placeholder={item.placeholder}
                            checked={!!filteredActions?.find((i) => i['codAcaoSeq'] === item['codAcaoSeq'])}
                            onCheck={(value) => checkItens((value))}
                            onChange={handleItens}
                            value={item}
                            nameAction={nameAction}
                            descAction={descAction}
                            id={id}
                        />
                    )
                }) || <div />}
            </>
        );
    }, [control, name, onChangeDefault, rules, actions, filteredActions, descAction, id, nameAction, handleItens]);

    return (
        <>
            {renderItems}
            {renderError()}
        </>
    );
};

export default ActionsGroup;